import { useEffect, useState } from "react";
import api, { errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { toast } from "sonner";

export default function SuperuserTierSwitcher() {
  const { lang } = useLang();
  const IT = lang === "it";
  const [tier, setTier] = useState("");
  const [switching, setSwitching] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    api.get("/subscriptions/status").then(r => setTier(r.data.tier || "base")).catch(() => {});
  }, []);

  const switchTo = async (next) => {
    if (next === tier || switching) return;
    setSwitching(true);
    try {
      await api.post("/superuser/set-tier", { tier: next });
      setTier(next);
      toast.success(IT ? `Tier: ${next}` : `Tier: ${next}`);
      setTimeout(() => window.location.reload(), 400);
    } catch (e) {
      toast.error(errMsg(e, "Error"));
    } finally { setSwitching(false); }
  };

  if (collapsed) {
    return (
      <button onClick={() => setCollapsed(false)} data-testid="tier-switcher-open"
        className="fixed bottom-4 right-4 z-50 rounded-full bg-primary text-primary-foreground w-11 h-11 shadow-lg hover:scale-105 transition-transform text-lg" title="Super-user tier switcher">
        🧪
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 border-2 border-primary/60 rounded-full bg-card shadow-lg px-3 py-2 flex items-center gap-2" data-testid="tier-switcher">
      <span className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">
        {IT ? "Super-user tier" : "Super tier"}
      </span>
      {["base", "pro", "enterprise", "corporate"].map((t) => (
        <button key={t} type="button" onClick={() => switchTo(t)} disabled={switching}
          data-testid={`tier-switch-${t}`}
          className={`text-[11px] uppercase tracking-wider px-2.5 py-1 rounded-full transition-all ${
            tier === t
              ? "bg-primary text-primary-foreground font-semibold"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          } ${switching ? "opacity-50" : ""}`}>
          {t}
        </button>
      ))}
      <button onClick={() => setCollapsed(true)} data-testid="tier-switcher-collapse"
        className="text-muted-foreground hover:text-foreground text-sm ml-1" title="Nascondi">
        ✕
      </button>
    </div>
  );
}
